import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isModalOpen: false,
  currentStep: 1, // 1 = Record Selection, 2 = Analysis
  selectedRowIds: [],
  selectedRecords: [],
  currentRecordIndex: 0,
  selectedPrompt: null,
  analysisResponses: {}, // Store LLM responses keyed by record ID
};

const analysisSlice = createSlice({
  name: 'analysis',
  initialState,
  reducers: {
    openAnalysisModal(state) {
      state.isModalOpen = true;
      state.currentStep = 1;
      state.selectedRowIds = [];
      state.selectedRecords = [];
      state.currentRecordIndex = 0;
      state.selectedPrompt = null;
      state.analysisResponses = {};
    },
    closeAnalysisModal(state) {
      state.isModalOpen = false;
      state.currentStep = 1;
      state.selectedRowIds = [];
      state.selectedRecords = [];
      state.currentRecordIndex = 0;
      state.selectedPrompt = null;
      state.analysisResponses = {};
    },
    setSelectedRows(state, action) {
      console.log('Redux analysisSlice - setSelectedRows called with:', action.payload);
      state.selectedRowIds = action.payload.rowIds;
      state.selectedRecords = action.payload.records;
      console.log('Redux analysisSlice - Updated state:', {
        selectedRowIds: state.selectedRowIds,
        selectedRecords: state.selectedRecords
      });
    },
    proceedToAnalysisStep(state) {
      state.currentStep = 2;
      state.currentRecordIndex = 0;
    },
    goBackToSelectionStep(state) {
      state.currentStep = 1;
    },
    setCurrentRecordIndex(state, action) {
      state.currentRecordIndex = action.payload;
    },
    navigateToNextRecord(state) {
      if (state.currentRecordIndex < state.selectedRecords.length - 1) {
        state.currentRecordIndex += 1;
      }
    },
    navigateToPreviousRecord(state) {
      if (state.currentRecordIndex > 0) {
        state.currentRecordIndex -= 1;
      }
    },
    setSelectedPrompt(state, action) {
      state.selectedPrompt = action.payload;
    },
    setAnalysisResponse(state, action) {
      const { recordId, response } = action.payload;
      state.analysisResponses[recordId] = response;
    },
    clearAnalysisResponse(state, action) {
      const { recordId } = action.payload;
      delete state.analysisResponses[recordId];
    },
  },
});

export const {
  openAnalysisModal,
  closeAnalysisModal,
  setSelectedRows,
  proceedToAnalysisStep,
  goBackToSelectionStep,
  setCurrentRecordIndex,
  navigateToNextRecord,
  navigateToPreviousRecord,
  setSelectedPrompt,
  setAnalysisResponse,
  clearAnalysisResponse,
} = analysisSlice.actions;

// Selectors
export const selectAnalysisState = (state) => state.analysis;
export const selectIsModalOpen = (state) => state.analysis.isModalOpen;
export const selectCurrentStep = (state) => state.analysis.currentStep;
export const selectSelectedRowIds = (state) => state.analysis.selectedRowIds;
export const selectSelectedRecords = (state) => state.analysis.selectedRecords;
export const selectCurrentRecordIndex = (state) => state.analysis.currentRecordIndex;
export const selectCurrentRecord = (state) => {
  const { selectedRecords, currentRecordIndex } = state.analysis;
  return selectedRecords[currentRecordIndex] || null;
};
export const selectSelectedPrompt = (state) => state.analysis.selectedPrompt;
export const selectAnalysisResponses = (state) => state.analysis.analysisResponses;
export const selectCurrentRecordAnalysis = (state) => {
  const currentRecord = selectCurrentRecord(state);
  if (!currentRecord) return null;
  return state.analysis.analysisResponses[currentRecord.id] || null;
};

export default analysisSlice.reducer;